import { render, staticRenderFns } from "./modelGoodsManage.vue?vue&type=template&id=55333756&scoped=true&"
import script from "./modelGoodsManage.vue?vue&type=script&lang=js&"
export * from "./modelGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./modelGoodsManage.vue?vue&type=style&index=0&id=55333756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55333756",
  null
  
)

export default component.exports